









import Vue from "vue";
import FixOrderItemTable from "../components/FixOrderItemTable.vue";
import { OrderItem } from "../models/OrderItem";
export default Vue.extend({
  components: {
    FixOrderItemTable
  },
  props: {
    value: {
      type: Array as () => OrderItem[]
    }
  },
  methods: {
    deleteProduct(index: number) {
      this.$emit("deleteProduct", index);
    }
  }
});
